import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
import { LeafSelect } from "../select/select.component.js";
import { LeafSelectOption } from "../select-option/select-option.component.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  display: none;\n}\n\n:host([active]) {\n  display: block;\n}\n\n.leaf-c-tab-section {\n  padding-top: var(--leaf-spacing-16);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafTabSection = class _LeafTabSection extends LeafElement {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  render() {
    const componentClassName = {
      "leaf-c-tab-section": true
    };
    return html`<section
      class=${classMap(componentClassName)}
      slot="section"
      id="${this.label}"
      role="tabpanel"
      aria-labelledby="${this.label}-tab"
      tabindex="-1"
    >
      <slot></slot>
    </section>`;
  }
};
_LeafTabSection.styles = unsafeCSS(styles);
_LeafTabSection.elementDefinitions = {
  "leaf-select": LeafSelect,
  "leaf-select-option": LeafSelectOption
};
let LeafTabSection = _LeafTabSection;
__decorateClass([
  property()
], LeafTabSection.prototype, "label", 2);
__decorateClass([
  property({ type: Boolean, attribute: "active" })
], LeafTabSection.prototype, "isActive", 2);
export {
  LeafTabSection
};
//# sourceMappingURL=tab-section.component.js.map
